import config from 'config';

import { stepperAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(stepperAnatomy.keys);

const {
  colors: {
    palette: {
      theme: { stepper: styles }
    }
  }
} = config;

const baseStyle = definePartsStyle({
  stepper: {
    gap: '3px'
  },

  step: {
    justifyContent: 'space-between',
    width: '100%',
    padding: '14px 17px',
    borderRadius: '3px',
    cursor: 'pointer',

    '&[data-status=active]': {
      background: styles.stepperStepActiveBg
    }
  },

  title: {
    fontSize: 14,
    fontWeight: 400,
    color: styles.stepperTitleColor,
    textTransform: 'uppercase',

    '&[data-status=active]': {
      fontWeight: 700,
      color: styles.stepperTitleActiveColor
    }
  }
});

const primaryVariantStyle = definePartsStyle({
  step: {
    background: styles.stepperPrimaryStepBg,
    '&[data-status=active]': {
      background: styles.stepperPrimaryStepActiveBg
    }
  },
  title: {
    '&[data-status=active]': {
      color: styles.stepperPrimaryTitleActiveColor
    }
  }
});

const secondaryVariantStyle = definePartsStyle({
  step: {
    background: styles.stepperSecondaryStepBg,
    '&[data-status=active]': {
      background: styles.stepperSecondaryStepActiveBg
    }
  },
  title: {
    color: styles.stepperSecondaryTitleColor,
    fontWeight: 'normal',
    '&[data-status=active]': {
      color: styles.stepperSecondaryTitleActiveColor,
      fontWeight: 'bold'
    }
  }
});

const Stepper = defineMultiStyleConfig({
  baseStyle,
  variants: {
    primary: primaryVariantStyle,
    secondary: secondaryVariantStyle
  },
  defaultProps: {
    variant: 'primary'
  }
});

export default Stepper;
